// extracted by mini-css-extract-plugin
module.exports = {"input":"Create_input__pkh4i","ant-tooltip-inner":"Create_ant-tooltip-inner__it3pK"};